// Authored by opencode-go/glm-5.3, session ses_f106f625dffeNEtOm9a2uWOTtI.
// Edited with Matthew, Hermes and unslop humanizer rules.
export const dapPurchaseCopy = {
  "title": "Dissolve Anxiety Program",
  "intro": "A self-paced 12-week course with lesson videos, guided audio, practical exercises and downloadable PDF resources.",
  "price": "AUD 247, paid once.",
  "refundHeading": "Refund policy",
  "refundBody": "Email info@matthewtweediehypnosis.com.au within 30 days of purchase for a full refund. Your rights under Australian Consumer Law are preserved.",
  "signInPrompt": "Sign in before buying so the course is added to your account.",
  "signInButton": "Sign in",
  "buyButton": "Buy now",
  "paying": "Taking you to Stripe's secure checkout.",
  "unavailable": "Checkout is unavailable. Please try again later.",
  "paymentPending": "We are checking your payment. Your course unlocks once payment is confirmed.",
  "openCourse": "Open your course",
  "refresh": "Refresh",
  "browserOnly": "This purchase page is available in a web browser."
}
